(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    class MaintenanceCountdown extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.target = this.parseTarget();
      this.update();
      if (this.target > Date.now()) this.interval = setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      this.stop();
    }

    stop() {
      clearInterval(this.interval);
    }

    parseTarget() {
      const date = this.dataset.date || '';
      const time = this.dataset.time || '';
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) return 0;

      const requested = `${date}T${time}:00`;
      const wallTime = Date.parse(`${requested}Z`);
      if (!Number.isFinite(wallTime)) return 0;

      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Helsinki', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
      });
      let target = wallTime;
      for (let attempt = 0; attempt < 4; attempt++) {
        const parts = Object.fromEntries(formatter.formatToParts(target).map(({ type, value }) => [type, value]));
        const local = `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`;
        if (local === requested) return target;
        target += wallTime - Date.parse(`${local}Z`);
      }
      return 0;
    }

    update() {
      const remaining = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
      const values = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor(remaining / 3600) % 24,
        minutes: Math.floor(remaining / 60) % 60,
        seconds: remaining % 60,
      };
      for (const [unit, value] of Object.entries(values)) {
        this.querySelector(`[data-unit="${unit}"]`).textContent = String(value);
      }
      for (const element of this.querySelectorAll('[data-running]')) element.hidden = remaining === 0;
      if (remaining === 0) this.stop();
    }
  }

  if (!customElements.get('maintenance-countdown')) {
    customElements.define('maintenance-countdown', MaintenanceCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
